import * as React from "react";
import {Stack} from "@mui/material";
import FixedVoiceFilter from "../filters/FixedVoiceFilter";
import FixedVoiceTable from "../tables/FixedVoiceTable";

function FixedVoice({legalEntity, dealer}: {legalEntity: string, dealer: string}) {

    return (
        <Stack direction={'column'} spacing={2} margin={"16px"}>
            <FixedVoiceFilter/>
            <FixedVoiceTable legalEntity={legalEntity} dealer={dealer}/>
        </Stack>
    )
}

export default FixedVoice;